(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blocksy-about-us"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const accordionItems = document.querySelectorAll('.blocksy-accordion-item');
    const blockContents = document.querySelectorAll('.blocksy-block-content');
    const firstAccordion = accordionItems[0];
    const firstContent = blockContents[0];

    accordionItems.forEach((item) => {
      const header = item.querySelector('.blocksy-accordion-header');
      const content = item.querySelector('.blocksy-accordion-content');

      header.addEventListener('click', () => {
        const id = item.dataset.block;
        const isActive = item.classList.contains('active');

        accordionItems.forEach((i) => {
          i.classList.remove('active');
          const c = i.querySelector('.blocksy-accordion-content');
          if (c) c.style.maxHeight = null;
        });

        blockContents.forEach((c) => c.classList.remove('active'));

        if (!isActive) {
          item.classList.add('active');
          const contentHeight = content.scrollHeight;

          if (contentHeight > 180) {
            content.style.maxHeight = '180px';
            content.style.overflowY = 'auto';
          } else {
            content.style.maxHeight = contentHeight + 'px';
            content.style.overflowY = 'hidden';
          }

          const leftContent = document.querySelector(`.blocksy-block-content[data-block="${id}"]`);
          if (leftContent) leftContent.classList.add('active');
        } else {
          if (firstAccordion && firstContent) {
            firstAccordion.classList.add('active');
            const firstAccContent = firstAccordion.querySelector('.blocksy-accordion-content');
            const firstHeight = firstAccContent.scrollHeight;

            if (firstHeight > 180) {
              firstAccContent.style.maxHeight = '180px';
              firstAccContent.style.overflowY = 'auto';
            } else {
              firstAccContent.style.maxHeight = firstHeight + 'px';
              firstAccContent.style.overflowY = 'hidden';
            }

            firstContent.classList.add('active');
          }
        }
      });
    });

    if (firstAccordion) {
      const firstAccContent = firstAccordion.querySelector('.blocksy-accordion-content');
      const firstHeight = firstAccContent.scrollHeight;

      if (firstHeight > 180) {
        firstAccContent.style.maxHeight = '180px';
        firstAccContent.style.overflowY = 'auto';
      } else {
        firstAccContent.style.maxHeight = firstHeight + 'px';
        firstAccContent.style.overflowY = 'hidden';
      }
    }
  });

  // For animation
  document.addEventListener('DOMContentLoaded', function () {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      mirror: true,
    });

    // Optional: refresh in case of Swiper or dynamic content
    setTimeout(function () {
      if (window.AOS) AOS.refresh();
    }, 500);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
